<div class="title" [ngStyle]="{color}">{{title | translate}}</div>
